import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { StrategyBuilderStateType } from "../reducer/strategyBuilder.reducer";

const state = (state: RootState) => state.strategyBuilderStore as StrategyBuilderStateType

export const selectStrategyBuilderTab = createDraftSafeSelector(state, (store) => store.selectedTab);
export const selectStrategyBuilderMode = createDraftSafeSelector(state, (store) => store.mode);
export const selectPredefinedStrategy = createDraftSafeSelector(state, (store) => store.predefinedStrategy);
export const selectStrategyBuilderTradingAccountId = createDraftSafeSelector(state, (store) => store.tradingAccountId);
export const selectViewTabs = createDraftSafeSelector(state, (store) => store.viewTabs);
export const selectTradeOrders = createDraftSafeSelector(state, (store) => store.tradeOrders);
export const selectOrderType = createDraftSafeSelector(state, (store) => store.orderType);
export const selectTradeProduct = createDraftSafeSelector(state, (store) => store.product);
export const selectStrategyBuilderLoading = createDraftSafeSelector(state, (store) => store.loading);
export const selectWaitingForOrders = createDraftSafeSelector(state, (store) => store.waitingForOrders);
export const selectStrategyBuilderError = createDraftSafeSelector(state, (store) => store.error);
export const selectStrategyGroup = createDraftSafeSelector(state, (store) => store.strategyGroup);
export const selectBasketId = createDraftSafeSelector(state, (store) => store.basketId);
export const selectBatchId = createDraftSafeSelector(state, (store) => store.batchId);
export const selectStrategyInfo = createDraftSafeSelector(state, (store) => store.strategyInfo);
export const selectTargetValues = createDraftSafeSelector(state, (store) => store.targetValues);
export const selectNearestExpiry = createDraftSafeSelector(state, (store) => store.nearestExpiry);
export const selectAddOrderEnabled = createDraftSafeSelector(state, (store) => store.addOrderEnabled);
export const selectExitStrategy = createDraftSafeSelector(state, (store) => store.exitStrategy);
export const selectBasketConditionalEntry = createDraftSafeSelector(
    state,
    (store) => store.basketConditionalEntry
);
export const selectBasketConditionalExit = createDraftSafeSelector(
    state,
    (store) => store.basketConditionalExit
);
export const selectLimitOrderPremium = createDraftSafeSelector(state, (store) => store.limitOrderPremium);
export const selectIceberg = createDraftSafeSelector(state, (store) => store.iceberg);
export const selectPayoffGraphData = createDraftSafeSelector(state, (store) => ({
    sdData: store.sdData,
    profitData: store.payoffProfitData,
    spotPrice: store.targetValues.spotBasePrice,
    optionsTradesData: store.optionsTradesData,
    payoffStrikes: store.payoffStrikes,
    payoffLegs: store.payoffLegs,
    payoffLegsPositions: store.payoffLegsPositions,
    breakevenPoints: store.strategyInfo.breakeven,
    targetPnl: store.targetPnl
}));



